var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowNarrowUpRight = function SvgArrowNarrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5c0-.46.373-.833.834-.833H15c.46 0 .834.373.834.833v6.666a.833.833 0 0 1-1.667 0V7.012L5.59 15.589a.833.833 0 0 1-1.179-1.178l8.578-8.578H8.333A.833.833 0 0 1 7.5 5Z",
    fill: "#0073D8"
  })));
};
export { SvgArrowNarrowUpRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNSA1YzAtLjQ2LjM3My0uODMzLjgzNC0uODMzSDE1Yy40NiAwIC44MzQuMzczLjgzNC44MzN2Ni42NjZhLjgzMy44MzMgMCAwIDEtMS42NjcgMFY3LjAxMkw1LjU5IDE1LjU4OWEuODMzLjgzMyAwIDAgMS0xLjE3OS0xLjE3OGw4LjU3OC04LjU3OEg4LjMzM0EuODMzLjgzMyAwIDAgMSA3LjUgNVoiIGZpbGw9IiMwMDczRDgiLz48L3N2Zz4=";